module.exports = __webpack_public_path__ + "static/media/augendusche_btn_richtig_inactive.ec7097e3.jpg";